export const Hero = () => {
  return (
    <section className="relative bg-white overflow-hidden">

      {/* Grid Background */}
      <div className="absolute inset-0">
        <div
          className="w-full h-full"
          style={{
            backgroundImage: `
              linear-gradient(#f1f5f9 1px, transparent 1px),
              linear-gradient(90deg, #f1f5f9 1px, transparent 1px)
            `,
            backgroundSize: "40px 40px",
          }}
        />
      </div>

      {/* Glow */}
      <div className="absolute top-[-80px] left-[-80px] w-[300px] h-[300px] bg-blue-200 rounded-full blur-[100px] opacity-40" />
      <div className="absolute bottom-[-80px] right-[-80px] w-[300px] h-[300px] bg-purple-200 rounded-full blur-[100px] opacity-40" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 text-center">

        {/* Badge */}
        <div className="mb-6 inline-block px-4 py-1 text-sm text-blue-600 rounded-full bg-blue-50">
          🚀 Software Development | Training | Internship | Career Growth
        </div>

        {/* Title */}
        <h1 className="text-4xl md:text-6xl font-extrabold text-gray-900 leading-tight mb-6">
          Build Real-World Tech Skills <br />
          <span className="text-blue-600">
            & Launch Your Career With Us
          </span>
        </h1>

        {/* Highlight */}
        <p className="text-lg font-semibold text-gray-800 mb-4">
          From Learning → To Earning → To Job Placement
        </p>

        {/* Description */}
        <p className="text-gray-600 text-lg mb-10 max-w-2xl mx-auto">
          We don’t just build software — we build developers.
          Work on real-time projects in Web, Mobile, AI/ML, and IoT.
          Get training, internships, stipend opportunities, and career support.
        </p>

        {/* Buttons */}
        <div className="flex justify-center gap-4 flex-wrap">

          <button className="px-8 py-3 rounded-xl bg-gradient-to-r from-blue-500 to-purple-600 text-white font-semibold shadow hover:scale-105 transition">
            Join Internship
          </button>

          <a href="/services" className="px-8 py-3 rounded-xl border border-gray-300 text-gray-700 hover:bg-gray-100 transition">
            View Services
          </a>

        </div>

      </div>
    </section>
  );
};